module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_1.266ab577.png";